<template>
  <div>
    <Modal
      v-model="visible"
      :title="productInfo.productName + `(${productInfo.productCode})`"
      width="1000"
      class="my-modal top add-product-modal"
      :footer-hide="true"
    >
      <div class="tools-box">
        <div class="right-box" v-if="!tableData.length">
          <Button type="primary" @click="goPage()">新增费用档次</Button>
        </div>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"></Table>
      </div>      

      <div class="ivu-modal-footer" v-if="!(status == '1' || status == '-1')">
        <Button @click="visible = false">取消</Button>
        <Button type="primary" @click="ok" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  props: ['status'],
  data() {
    return {
      visible: false,
      productInfo: {},
      activityId: '',
      selectArr: [], //表格选择的数据
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '序号',
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '险种名称',
          key: 'gradeName',
          width: 320,
          align: 'center',
          render(h, params) {
            if (params.row.isMain == 1) {
              return <span>{params.row.gradeName}</span>;
            } else {
              return (
                <div>
                  <Tag color="blue">附</Tag>
                  <span>{params.row.gradeName}</span>
                </div>
              );
            }
          }
        },
        {
          title: '方案名称',
          key: 'programName',
          align: 'center'
        },
        {
          title: '保障期',
          key: 'guaranteeContent',
          align: 'center'
        },
        {
          title: '交费期',
          key: 'payTerm',
          align: 'center'
        }
      ],
      loading: false
    };
  },

  methods: {
    open(data, activityId) {
      this.visible = true;
      this.productInfo = data;
      this.activityId = activityId;
      this.selectArr = [];
      this.getList();
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/merchantActivity/queryProductGrade',
        type: 'POST',
        data: {
          activityId: this.activityId,
          productCode: this.productInfo.productCode,
          productId: this.productInfo.productId,
          pageSize: 99,
          pageNo: 1
        }
      })
        .then(res => {
          res.data.forEach(item => {
            item.key = item.gradeCode + item.programId;
            item._checked = item.isAdd == '1' ? true : false;
            if (item.isAdd == '1') {
              this.selectArr.push(item);
            }
            this.selectArr.forEach(item2 => {
              if (item.key == item2.key) {
                item._checked = true;
              }
            });
          });
          this.total = res.total;
          this.tableData = res.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.key); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.key); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.key) && !selectIds.includes(item.key)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.key);
        } else if (!ids.includes(item.key) && selectIds.includes(item.key)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.key), 1);
          selectIds.splice(selectIds.indexOf(item.key), 1);
        }
      });
    },

    ok() {
      if (this.listLoading) {
        return;
      }
      if (!this.selectArr.length) {
        this.$notice.msg('至少需要勾选一个信息');
        return;
      }
      this.$http({
        url: '/buz/merchantActivity/saveProductDetailConfig',
        type: 'POST',
        data: {
          activityId: this.activityId,
          detailList: this.selectArr
        }
      }).then(res => {
        this.$notice.success('配置成功');
        this.visible = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.add-product-modal {
  padding-top: 20px;
  .btn3 {
    padding-right: 100px;
  }
  .search-wrap {
    margin: 10px 0;
    .ivu-btn {
      position: absolute;
      right: 30px;
    }
    .ivu-select-selection {
      border-radius: 2px;
      height: 30px;
    }
  }
  .ivu-tabs-nav-container {
    font-size: 16px;

    .ivu-tabs-tab {
      padding: 10px 24px;
    }
  }
  /deep/.ivu-modal-body {
    padding-top: 20px;
  }
}
</style>
